module.exports = __webpack_public_path__ + "img/banner.fd6dd92a.png";